import { getCookie } from '@/common/js/cookie.js';
import { apiUrl } from '@/common/js/base.js';
import { doLogin } from '@/test';
import WebApi from './bridge/WebApi.js';
import ClientApi from './bridge/ClientApi.js';
const { brower } = require('@/common/wxJs/wx-util');
import store from '@/store'

window.WebApi = WebApi;
export async function isLogin(appId, callback) {
  const tk = getCookie('token');
  let isLogin = true;
  const user = getCookie('user');
  const userInToken = tk? window.xhCloud.outSdkUtils.decodeJwtToken(tk) : '' // 从token中获取用户信息
  console.log('登录状态验证');
  if (!userInToken && !user && !tk) {
    console.log('token为空或者用户信息为空');
    isLogin = false;
    return callback(isLogin);
  }
  //二次校验,判断当前登录的user appid是否和appCode一样
  if (isLogin) {

    let temp = {}
      if (userInToken) {
        temp = userInToken.userInfo
      } else {
        temp = JSON.parse(decodeURIComponent(user))
      }
    console.log(temp, '用户信息');
    if (!brower.version.weixin) {
      try {
        if (window.isThirdApp) {
          // const info = await getThirdUsrInfo();
          // isLogin = info.account_id == temp.thirdId
          return callback(isLogin);
        } else {
          WebApi.getInstance().subscribeAction('appUserId', function(info) {
            console.log(info, '从 app中获取用户信息');
            isLogin = temp.appId === appId && info.userId == temp.thirdId;
            return callback(isLogin);
          });
          ClientApi.getInstance().JSCallNative('getUserId', {}, 'appUserId');
        }
      } catch (e) {
        isLogin = temp.appId === appId;
        return callback(isLogin);
      }
    } else {
      // isLogin = temp.appId === appId;
      return callback(false);
    }
  }

  // if (!isLogin) {
  //     doLogin()
  // }
  //已授权则直接执行，未授权则去授权
  return callback(isLogin);
}
// 从三方获取用户信息
function getThirdUsrInfo() {
  return new Promise(resolve => {
    window.xhCloud.getUserId({ success: resolve });
  });
}

export function appLoginUtil(appStr) {
  appStr = appStr || sessionStorage.getItem('appJson');
  if (!appStr) {
    return false;
  }
  let res = JSON.parse(appStr);
  if (!res.appLoginConfig) {
    return false;
  }
  if (res.appLoginConfig.hasAppLogin == 1 && res.appLoginConfig.appLoginWay) {
    if (window.ryUserLogin) {
      try {
        window.ryUserLogin({
          key: 'ryLogin',
          ryredirect: window.location.href.replace(/&authKey=.*/g, ''),
          application: 'entry',
        });
      } catch (e) {
        console.log(e);
      }
    }
    return true;
  }
  if (res.appLoginConfig.hasH5Login == 1 && res.appLoginConfig.h5LoginWay) {
    window.location.href = res.appLoginConfig.h5LoginWay;
    return true;
  }
  return true;
}

export function getWxAuth() {
  // let url =
  //   wxUrl +
  //   `/wechatoauthapi/oauth2/checkLogin?appCode=${appCode}&callbackUrl=${encodeURIComponent(
  //     location.href,
  //   )}` +
  //   '&red=1';
  // window.location.href = url;
  // 处理之前在绑定手机号后存在cookie里面的userInfo信息错误问题
  const appCode = localStorage.getItem('appId');
  if (location.href.indexOf('red') < 0) {
    const token = getCookie('token');
    try {
      let user = getCookie('user');
      if (typeof user === 'string') {
        user = JSON.parse(user);
      }
      if (!token) {
        wxLogin();
        store.commit('SET_LOGIN_STATUS', false);
      } else {
        let tokenInfo = getTokenInfo(token);
        let { exp, appId } = tokenInfo;
        let nowDate = Date.parse(new Date()) / 1000;
        if (exp - nowDate < 5 * 3600 || appId != appCode) {
          wxLogin();
          store.commit('SET_LOGIN_STATUS', false);
        } else {
          store.commit('SET_LOGIN_STATUS', true);
        }
        console.log('tokenInfo', tokenInfo);
      }
    } catch (error) {
      this.wxLogin();
      store.commit('SET_LOGIN_STATUS', false);
    }
  } else {
    store.commit('SET_LOGIN_STATUS', true);
  }
}
function wxLogin() {
  let appCode = localStorage.getItem('appId');
  const wxUrl = apiUrl.wxBaseUrl;
  let url = `${wxUrl}/wechatoauthapi/oauth2/checkLogin?appCode=${appCode}&callbackUrl=${encodeURIComponent(
    `${
      window.location.href.indexOf('?') > 0
        ? `${window.location.href}&red=1`
        : `${window.location.href}?red=1`
    }`,
  )}`;
  window.location.href = url;
}

function getTokenInfo(token) {
  let strings = token.split('.'); //截取token，获取载体
  let tokenInfo = '';
  tokenInfo = JSON.parse(
    decodeURIComponent(
      escape(window.atob(strings[1].replace(/-/g, '+').replace(/_/g, '/'))),
    ),
  );
  tokenInfo = {
    ...tokenInfo,
    userInfo: JSON.parse(tokenInfo.sub),
  };
  return tokenInfo;
}



// WEBPACK FOOTER //
// ./src/common/js/userCtrl.js